<p #textContainer [ngStyle]="{'height': expanded() ? 'auto' : (this.minRows()*lineHeight/16)+'rem'}">
  {{text}}

  <span class="see-more-cta" [ngStyle]="{
    'position': expanded() ? 'static' : 'absolute',
    'display': expanded() ? 'inline-block':'flex'
    }">

    @if(rows() > 2){

    @if(!expanded()){
    <span>{{expanded() ? '' : '...'}}</span>
    }

    <a class="btn btn-link" role="button" (click)="expanded.set(!expanded())">
      {{expanded() ? ('Read less'|translate) : ('Read more'|translate)}}
    </a>

    }

  </span>
</p>
